import { ReservationStatus, Trip, TransitProgram, VehicleType } from '@uzurv/clara';
import * as RideTrackingActions from './ride-tracking.actions';
import { Tabs } from '../../pages/ride-tracking/ride-tracking.page';
import { createReducer, on } from '@ngrx/store';

export interface RideTrackingState {
  loading: boolean;
  currentTab: Tabs;
  pageNumber: number;
  pageSize: number;
  reservationStatuses: Array<ReservationStatus>;
  selectedTransitPrograms: Array<TransitProgram>;
  selectedVehicleTypes: Array<VehicleType>;
  selectedReservationStatuses: Array<ReservationStatus>;
  rides: Array<Trip>;
}

export const initialState: RideTrackingState = {
  loading: false,
  currentTab: Tabs.PENDING,
  pageNumber: 0,
  pageSize: 20,
  reservationStatuses: [],
  selectedTransitPrograms: [],
  selectedVehicleTypes: [],
  selectedReservationStatuses: [],
  rides: []
};

export const rideTracking = createReducer(
  initialState,
  on(RideTrackingActions.RestoreState, (_, action) => action.state),

  on(RideTrackingActions.ChangeTab, (state, action) => {
    return {
      ...state,
      rides: [],
      loading: true,
      currentTab: action.tabs,
      pageNumber: initialState.pageNumber,
      pageSize: initialState.pageSize
    };
  }),

  on(RideTrackingActions.GetRides, state => {
    return {
      ...state,
      loading: true
    };
  }),

  on(RideTrackingActions.GetRidesSuccess, (state, action) => {
    return {
      ...state,
      rides: action.trips,
      loading: false
    };
  }),

  on(RideTrackingActions.GetRidesFail, state => {
    return {
      ...state,
      loading: false
    };
  }),

  on(RideTrackingActions.GetReservationStatusesSuccess, (state, action) => {
    return {
      ...state,
      reservationStatuses: action.reservationStatuses
    };
  }),

  on(RideTrackingActions.PageRides, (state, action) => {
    return {
      ...state,
      rides: [],
      loading: true,
      pageNumber: action.pageEvent.pageIndex,
      pageSize: action.pageEvent.pageSize
    };
  }),

  on(RideTrackingActions.SelectTransitPrograms, (state, action) => {
    return {
      ...state,
      rides: [],
      loading: true,
      selectedTransitPrograms: action.transitPrograms
    };
  }),

  on(RideTrackingActions.SelectVehicleTypes, (state, action) => {
    return {
      ...state,
      rides: [],
      loading: true,
      selectedVehicleTypes: action.vehicleTypes
    };
  }),

  on(RideTrackingActions.SelectReservationStatuses, (state, action) => {
    return {
      ...state,
      rides: [],
      loading: true,
      selectedReservationStatuses: action.reservationStatuses
    };
  })
);
